<ami-table-actions
  [settings]="table.settings"
  [data]="table.data"
  [actions]="table.actions"
></ami-table-actions>
